export default __webpack_public_path__ + "static/media/outlook.76493c9e.svg";